import { t } from 'i18next';
import { DateTimeFormatter, dateFormat } from '../../../common/formatter/DateTimeFormatter';

export const formatDissolveDate = (date: Date | undefined) => {
  if (!date) return '-';

  const formattedDate = DateTimeFormatter.format(date, { format: dateFormat });
  return t('dashboard.contractsOverlay.dissolveValues.due', { date: formattedDate });
};

export const getEndOfMonth = (date: Date | undefined, next: number = 0) => {
  if (!date) return undefined;

  return new Date(date.getFullYear(), date.getMonth() + next + 1, 0);
};

export const getDatepartOnly = (date: Date | undefined) => {
  if (!date) return undefined;

  const result = new Date(date);
  result.setHours(0, 0, 0, 0);
  return result;
};

export const getValueWithVatCoefficientApplied = (
  value: number | undefined,
  vatCoefficient: number
) => {
  if (!value) return 0;
  return value * vatCoefficient;
};

export const isSameDay = (date1: Date | undefined, date2: Date | undefined): boolean => {
  if (!date1 || !date2) return false;

  const date1Only = getDatepartOnly(date1);
  const date2Only = getDatepartOnly(date2);

  return date1Only?.getTime() === date2Only?.getTime();
};
